import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import image from "../../assets/images/dummy_pic.jpeg"; // Default image
import { BaseURL, uniqueToken } from "../../api/DataApis";
import { GpsBaseURL } from "../../api/DataApis";
import './User.css'; // Custom styles

const View = () => {
  document.title = "Order | View";
  const [OrderData, setOrderData] = useState({});
  const [loading, setLoading] = useState(true); // State to manage loader
  const [cashfree, setcashfree] =  useState(false);
  // const [PaymentData, setPaymentData] = useState({}) ;
  const params = useParams();
  const UserID = params.cid;

  const fetchData = async () => {
    const apiEndpoint = `${GpsBaseURL}/order/details/${UserID}`;

    try {
      let res = await axios.get(apiEndpoint, {
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${uniqueToken}`,
        }
      });
      if (res && res.data && res.data.data && res.data.data.length > 0) {
        setOrderData(res.data.data[0]);
        // setPaymentData(res.data.data[0]?.userOrders?.paymentData)
        if(res.data?.data[0]?.userOrders?.paymentData?.payment_gateway_details?.gateway_name ==="CASHFREE") {
          setcashfree(true);
        }
      } else {
        console.error("No user data found");
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setLoading(false); // Stop loader when data is fetched
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  const paymentData = OrderData?.userOrders?.paymentData;
console.log("OrderData", OrderData);
console.log("PaymentData", paymentData);

  return (
    <div className="container my-5">
      <div className="card shadow-lg p-4">
        {loading ? (
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        ) : (
          <>
            {/* Page Title */}
            <h1 className="page-title text-center mb-4">Order Details</h1>

            {/* Profile Image and Basic Info */}
            <div className="profile-header text-center">
              <img
                className="profile-image rounded-circle mb-4"
                src={OrderData?.logo ? OrderData?.logo : image}
                alt="Profile"
                style={{ width: '150px', height: '150px', objectFit: 'cover', border: '3px solid #ddd' }}
              />
              <h5 className="user-name mb-1">{OrderData?.name}</h5>
              {/* <p className="user-role">Class:&nbsp; <b>{Users?.userType}</b></p> */}
            </div>

            {/* Personal Information Section */}
            {cashfree && (
            <div className="profile-info mt-4">
              <h3 className="section-title">Order Information</h3>
              <div className="row">
              <div className="col-md-6 mb-3">
  <p><strong>Name: &nbsp;</strong>{OrderData?.name}</p>
  <p><strong>Phone: &nbsp; </strong>{OrderData?.mobile}</p>
  <p><strong> BC Agent ID: &nbsp;</strong>{OrderData?.bc_agent_id}</p>
  <p><strong> District: &nbsp;</strong>{OrderData?.district}</p>
  <p><strong>Created Date: &nbsp;</strong>{OrderData?.createdAt}</p>
  <p><strong>Status: &nbsp;</strong>{OrderData?.status}</p>
  <p><strong>Customer ID: </strong>{paymentData?.customer_details?.customer_id}</p>
  

</div>
<div className="col-md-6 mb-3">
  <p><strong>BC Corporate Name: </strong>{OrderData?.bc_corporate_name}</p>
  <p><strong>Email: &nbsp;</strong>{OrderData?.email}</p>
  <p><strong>Address: &nbsp;</strong>{OrderData?.address}</p>
  <p><strong>Is Email Sent: &nbsp;</strong>{OrderData?.is_email_sent}</p>
  <p><strong>Updated Date: &nbsp;</strong>{OrderData?.updatedAt}</p>
  <p><strong>AWB Date: &nbsp;</strong>{OrderData?.awb_date}</p>
</div>


<h4>Product Details</h4>
{OrderData?.userOrders?.items.map((u, i) => (
  <>
    <div className="row mb-3"> {/* Add row to contain the two columns */}
      {/* Product Details */}
      <div className="col-md-6 mb-3">
       <p><strong>Product Name: </strong>{u?.product_name}</p>
        <p><strong>Quantity: &nbsp;</strong>{u?.quantity}</p>
        <p><strong>OrderID: &nbsp;</strong>{u?.orderId}</p>
      </div>

      {/* Payment Status and Order Info */}
      <div className="col-md-6 mb-3">
      <p><strong>Price: &nbsp;</strong>{u?.price}</p>
       <p><strong>Product Image: &nbsp;</strong><img src={u?.product_image} alt="Product Image" className="img-fluid" /></p>
       </div>
    </div>
    
    {/* Horizontal Line after each product */}
    <hr />
  </>
))}
{OrderData?.userOrders?.items[0]?.comboItems?.map((u, i) => (
  <>
    <div className="row mb-3"> {/* Add row to contain the two columns */}
      {/* Combo Product Details */}
      <div className="col-md-6 mb-3">
        <h4> Combo Product Details</h4>
        <p><strong>Product Name: </strong>{u?.product_id?.title}</p>
        <p><strong>Description: &nbsp;</strong>{u?.product_id?.description}</p>
      </div>
      
      {/* Combo Product Price and Image */}
      <div className="col-md-6 mb-3">
        <p><strong>Price: &nbsp;</strong>{u?.product_id?.price}</p>
        <p><strong>Product Image: &nbsp;</strong><img src={u?.product_id?.product_image} alt="Product Image" className="img-fluid small-image"  style={{ "maxWidth": '150px', "height": 'auto' }}  /></p>

      </div>
    </div>
    
    {/* Horizontal Line after each combo product */}
    <hr />
  </>
))}

<h4>Payment Details</h4>
<div className="row mb-3">


  {/* Order Details */}
  <div className="col-md-6 mb-3">
    <p><strong>Order ID: </strong>{paymentData?.order?.order_id}</p>
    <p><strong>Order Amount: </strong>{paymentData?.order?.order_amount}</p>
    <p><strong>Order Currency: </strong>{paymentData?.order?.order_currency}</p>
    <p><strong>Order Tags: </strong>{paymentData?.order?.order_tags || "N/A"}</p>
  </div>

  {/* Payment Information */}
  <div className="col-md-6 mb-3">
    <p><strong>Payment ID: </strong>{paymentData?.payment?.cf_payment_id}</p>
    <p><strong>Payment Amount: </strong>{paymentData?.payment?.payment_amount}</p>
    <p><strong>Payment Currency: </strong>{paymentData?.payment?.payment_currency}</p>
     <p><strong>Payment Method: </strong>{paymentData?.payment?.group}</p>
   <p><strong>Payment Group: </strong>{paymentData?.payment?.payment_group}</p>
    <p><strong>Payment Status: </strong>{paymentData?.payment_status}</p>
    <p><strong>Payment Time: </strong>{paymentData?.payment_time}</p>
  </div>

  {/* UPI Details */}
  <div className="col-md-6 mb-3">
     <p><strong>UPI ID: </strong>{paymentData?.payment?.payment_method?.upi?.upi_id}</p> 
   <p><strong>Bank Reference: </strong>{paymentData?.payment?.bank_reference}</p>
    <p><strong>Authorization ID: </strong>{paymentData?.payment?.auth_id || "N/A"}</p>
    <p><strong>Transaction Message: </strong>{paymentData?.payment?.payment_message}</p> 
  </div>

  {/* Payment Gateway Details */}
  <div className="col-md-6 mb-3">
    <p><strong>Gateway Name: </strong>{paymentData?.payment_gateway_details?.gateway_name}</p>
    <p><strong>Gateway Order ID: </strong>{paymentData?.payment_gateway_details?.gateway_order_id}</p>
    <p><strong>Gateway Payment ID: </strong>{paymentData?.payment_gateway_details?.gateway_payment_id}</p>
    <p><strong>Gateway Status Code: </strong>{paymentData?.payment_gateway_details?.gateway_status_code || "N/A"}</p>
    <p><strong>Gateway Order Reference: </strong>{paymentData?.payment_gateway_details?.gateway_order_reference_id || "N/A"}</p>
  </div>

  {/* Razorpay Payment ID */}
  <div className="col-md-6 mb-3">
    <p><strong>Razorpay Payment ID: </strong>{paymentData?.razorpay_payment_id}</p>
  </div>
</div>

    </div>
 </div>
  
        )}
                 {!cashfree && (
            <div className="profile-info mt-4">
              <h3 className="section-title">Order Information</h3>
              <div className="row">
              <div className="col-md-6 mb-3">
  <p><strong>Name: &nbsp;</strong>{OrderData?.name}</p>
  <p><strong>Phone: &nbsp; </strong>{OrderData?.mobile}</p>
  <p><strong> BC Agent ID: &nbsp;</strong>{OrderData?.bc_agent_id}</p>
  <p><strong> District: &nbsp;</strong>{OrderData?.district}</p>
  <p><strong>Created Date: &nbsp;</strong>{OrderData?.createdAt}</p>
  <p><strong>Status: &nbsp;</strong>{OrderData?.status}</p>
  

</div>
<div className="col-md-6 mb-3">
  <p><strong>BC Corporate Name: </strong>{OrderData?.bc_corporate_name}</p>
  <p><strong>Email: &nbsp;</strong>{OrderData?.email}</p>
  <p><strong>Address: &nbsp;</strong>{OrderData?.address}</p>
  <p><strong>Is Email Sent: &nbsp;</strong>{OrderData?.is_email_sent}</p>
  <p><strong>Updated Date: &nbsp;</strong>{OrderData?.updatedAt}</p>
  <p><strong>AWB Date: &nbsp;</strong>{OrderData?.awb_date}</p>
</div>


<h4>Product Details</h4>
{OrderData?.userOrders?.items.map((u, i) => (
  <>
    <div className="row mb-3"> {/* Add row to contain the two columns */}
      {/* Product Details */}
      <div className="col-md-6 mb-3">
       <p><strong>Product Name: </strong>{u?.product_name}</p>
        <p><strong>Quantity: &nbsp;</strong>{u?.quantity}</p>
        <p><strong>OrderID: &nbsp;</strong>{u?.orderId}</p>
      </div>

      {/* Payment Status and Order Info */}
      <div className="col-md-6 mb-3">
      <p><strong>Price: &nbsp;</strong>{u?.price}</p>
       <p><strong>Product Image: &nbsp;</strong><img src={u?.product_image} alt="Product Image" className="img-fluid" /></p>
       </div>
    </div>
    
    {/* Horizontal Line after each product */}
    <hr />
  </>
))}
{OrderData?.userOrders?.items[0]?.comboItems?.map((u, i) => (
  <>
    <div className="row mb-3"> {/* Add row to contain the two columns */}
      {/* Combo Product Details */}
      <div className="col-md-6 mb-3">
        <h4> Combo Product Details</h4>
        <p><strong>Product Name: </strong>{u?.product_id?.title}</p>
        <p><strong>Description: &nbsp;</strong>{u?.product_id?.description}</p>
      </div>
      
      {/* Combo Product Price and Image */}
      <div className="col-md-6 mb-3">
        <p><strong>Price: &nbsp;</strong>{u?.product_id?.price}</p>
        <p><strong>Product Image: &nbsp;</strong><img src={u?.product_id?.product_image} alt="Product Image" className="img-fluid small-image"  style={{ "maxWidth": '150px', "height": 'auto' }}  /></p>

      </div>
    </div>
    
    {/* Horizontal Line after each combo product */}
    <hr />
  </>
))}

<h4>Payment Details</h4>
<div className="row mb-3"> {/* Add row to contain the two columns */}
      {/* Product Details */}
      <div className="col-md-6 mb-3">
       <p><strong>Entity: </strong>{paymentData?.entity}</p>
        <p><strong>Amount: &nbsp;</strong>{paymentData?.amount}</p>
        <p><strong>Currency: &nbsp;</strong>{paymentData?.currency}</p>
        <p><strong>VPA: &nbsp;</strong>{paymentData?.vpa}</p>
        <p><strong>Email: &nbsp;</strong>{paymentData?.email}</p>
        <p><strong>Contact: &nbsp;</strong>{paymentData?.contact}</p>
        <p><strong>Upi_transaction_id: &nbsp;</strong>{paymentData?.acquirer_data?.upi_transaction_id}</p>
      </div>

      {/* Payment Status and Order Info */}
      <div className="col-md-6 mb-3">
      <p><strong>Status: </strong>{paymentData?.status}</p>
        <p><strong>OrderID: &nbsp;</strong>{paymentData?.order_id}</p>
        <p><strong>International: &nbsp;</strong>{paymentData?.international}</p>
        <p><strong>fee: </strong>{paymentData?.status}</p>
        <p><strong>tax: &nbsp;</strong>{paymentData?.order_id}</p>
        <p><strong>RRN: &nbsp;</strong>{paymentData?.acquirer_data?.rrn}</p>
        
       </div>
    </div>
 </div>
  </div>
        )}
          </>
        )}
      </div>
    </div>
  );
};

export default View;
